import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Dispatch } from 'redux';
import { handleTimerStatus } from '../../actions/activities.actions';
import { Rep } from '../../classes/Workout';
import './Timer.css';

interface TimerProps extends WithTranslation {
    raw?: boolean,
    updateTime: any,
    dispatch: Dispatch<any>;
    activityStatus: string;
    timerStatus:string;
    currentRep:Rep;
}

interface TimerState {
    elapsedTimeInTenthofSeconds: number;
    startingTime: number;
    beforePausedTime: number;
    intervalId: NodeJS.Timeout | null;
}

class Timer extends Component<TimerProps, TimerState> {
    constructor(props: TimerProps) {
        super(props);
        this.state = {
            elapsedTimeInTenthofSeconds: 0,
            startingTime: Date.now(),
            beforePausedTime: 0,
            intervalId: null,
        };
    }

    componentDidMount() {
        // Don't automatically start the timer - wait for explicit timerStatus changes
        // The timer will be started when timerStatus becomes 'start'
    }

    componentDidUpdate(prevProps: TimerProps) {
        if (this.props.timerStatus !== prevProps.timerStatus) {
            switch (this.props.timerStatus) {
                case "start": 
                    this.startTimer();
                    this.props.dispatch(handleTimerStatus('working'));
                    break;               
                case "reset" :
                    this.resetTimer();
                    // Don't dispatch 'working' here - let SimpleWorkoutManager handle it
                    break;
                case "pause":
                    this.setState({
                        beforePausedTime: this.state.elapsedTimeInTenthofSeconds
                    });
                    this.pauseTimer();
                    break;
                case "stop":
                    this.stopTimer();
                    break;
            }
        }

        if (this.props.activityStatus !== prevProps.activityStatus) {
            if (this.props.activityStatus === 'stop') {
                this.stopTimer();
            }
        }

        if (this.props.currentRep && this.state.elapsedTimeInTenthofSeconds > this.props.currentRep.time && !this.props.activityStatus.includes('wait') && this.props.timerStatus === 'working') {
            this.props.dispatch(handleTimerStatus('done'));
        }

        // Time updates are now handled in the interval callback in startTimer
        // No need to call updateTime here as it would cause duplicate calls
    }

    componentWillUnmount() {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
    }

    startTimer = () => {
        // Prevent multiple starts
        if (this.state.intervalId) {
            return; // Already running
        }

        const startTime = Date.now();
        const intervalId = setInterval(() => {
            const elapsed = (Date.now() - startTime) / 1000 + this.state.beforePausedTime;
            this.setState({ elapsedTimeInTenthofSeconds: elapsed });
            this.props.updateTime(elapsed);
        }, 100);

        this.setState({
            intervalId,
            startingTime: startTime,
        });
    }

    pauseTimer = () => {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.setState({ intervalId: null });
        }
    }

    stopTimer = () => {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
        this.setState({
            elapsedTimeInTenthofSeconds: 0,
            beforePausedTime: 0,
            intervalId: null
        });
    }

    resetTimer = () => {
        // Stop the running interval so startTimer() can create a fresh one.
        // Without this, startTimer()'s guard (`if (this.state.intervalId) return`)
        // would prevent the next rep's timer from ever starting.
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
        this.setState({
            elapsedTimeInTenthofSeconds: 0,
            beforePausedTime: 0,
            startingTime: Date.now(),
            intervalId: null,
        });
    }

    formatTime = (timeInSeconds: number): string => {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = Math.floor(timeInSeconds % 60);
        const tenths = Math.floor((timeInSeconds % 1) * 10);
        
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${tenths}`;
    }

    // Debug method to check timer state
    debugTimerState = () => {
        console.log('Timer: Internal state:', {
            elapsedTimeInTenthofSeconds: this.state.elapsedTimeInTenthofSeconds,
            startingTime: this.state.startingTime,
            beforePausedTime: this.state.beforePausedTime,
            intervalId: this.state.intervalId,
            timerStatus: this.props.timerStatus,
            activityStatus: this.props.activityStatus,
            currentRep: this.props.currentRep
        });
    };

    render() {
        const { raw, timerStatus } = this.props;
        
        if (raw) {
            return (
                <div className="timer-raw">
                    {
                    //this.formatTime(elapsedTimeInTenthofSeconds)
                    }
                </div>
            );
        }

        return (
            <div className="timer-container">
                <div className="timer-display">
                    <span className="timer-label"></span>
                    <span className="timer-value">
                        {
                        //this.formatTime(elapsedTimeInTenthofSeconds)
                        }
                    </span>
                </div>
                
                <div className="timer-status">
                    <span className={`status-indicator ${timerStatus}`}>
                        {
                        //timerStatus === 'working' ? '▶' : 
                        // timerStatus === 'pause' ? '⏸' : 
                         //timerStatus === 'done' ? '✓' : '●'
                         }
                    </span>
                    <span className="status-text">
                        {
                        //timerStatus === 'working' ? 'Working' : 
                         //timerStatus === 'pause' ? 'Paused' : 
                         //timerStatus === 'done' ? 'Done' : 'Ready'
                         }
                    </span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    activityStatus: state.activities.activityStatus,
    timerStatus: state.activities.timerStatus,
    currentRep: state.activities.currentRep,
});

export default withTranslation('workout')(connect(mapStateToProps)(Timer))